var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.17 17.17L24 26.34l-9.17-9.17L12 20l12 12 12-12z"}));
}

ChevronDown.displayName = "ChevronDown";

ChevronDown.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/chevron_down.svg